import { render, staticRenderFns } from "./BaseFileUpload.vue?vue&type=template&id=2a45b9f0&"
import script from "./BaseFileUpload.vue?vue&type=script&lang=ts&"
export * from "./BaseFileUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports